import { createAsyncThunk } from '@reduxjs/toolkit';
import { environment } from '../../environments';
import { 
  ProjectHeaderRequest, 
  ProjectHeaderResponse,
  UpdateProjectHeaderRequest,
  UpdateProjectHeaderResponse
} from '../../models/Project.model';

const API_BASE_URL = environment.apiUrl;

// קבלת כותרת פרויקט
export const getProjectHeader = createAsyncThunk<
  ProjectHeaderResponse,
  ProjectHeaderRequest,
  { rejectValue: string }
>(
  'projectHeader/getProjectHeader',
  async (requestData, { rejectWithValue }) => {
    try {
        const response = await fetch(`${API_BASE_URL}Project/GetProjectHeader`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(requestData),
      });

      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      const data: ProjectHeaderResponse = await response.json();
      
      if (!data.success) return rejectWithValue(data.message || 'Failed to fetch project header');
      return data;
    } catch (error) {
      return rejectWithValue(error instanceof Error ? error.message : 'Unknown error');
    }
  }
);

// עדכון כותרת פרויקט
export const updateProjectHeader = createAsyncThunk<
  UpdateProjectHeaderResponse,
  UpdateProjectHeaderRequest,
  { rejectValue: string }
>(
  'projectHeader/updateProjectHeader',
  async (requestData, { rejectWithValue }) => {
    try {
        const response = await fetch(`${API_BASE_URL}Project/UpdateProjectHeader`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(requestData),
      });

      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      const data: UpdateProjectHeaderResponse = await response.json();
      
      if (!data.success) return rejectWithValue(data.message || 'Failed to update project header');
      return data;
    } catch (error) {
      return rejectWithValue(error instanceof Error ? error.message : 'Unknown error');
    }
  }
);